import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { EmployeeStatusesEnum } from '@thinknet-gmbh/platform-common';

export const EMPLOYEE_STATUSES_STYLES = {
  [EmployeeStatusesEnum.ACTIVE]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [EmployeeStatusesEnum.DRAFT]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [EmployeeStatusesEnum.INACTIVE]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
};

export const EMPLOYEE_MODALS = {
  tableFilter: 'tableFilter',
  changeStatus: 'changeStatus',
  createAbsence: 'createAbsence',
  createInterview: 'createInterview',
};

export const INITIAL_EMPLOYEE_DATA = {
  _id: '',
  employeeId: '',
  profile: {
    firstName: '',
    lastName: '',
  },
  company: '',
  location: '',
  department: '',
  jobTitle: '',
  supervisor: '',
  status: '',
  createdAt: '',
};
